import React, { Component } from 'react';

export default class Overlay extends Component {

    handleClick() {
        this.props.onClick();
    }

    render() {
        const style = {
            base: {
                opacity: this.props.isVisible ? 1 : 0,
                pointerEvents: this.props.isVisible ? 'auto' : 'none',
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(255,255,255,0.9)',
                transition: 'all .3s ease-in-out',
                zIndex: 995,
            },
        };

        return (
            <div onClick={this.handleClick.bind(this)} style={style.base}></div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Overlay.js